import React, { Fragment, useState } from "react";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

import { campDetails } from "./CoordinatorsData";
import "./Eventpage.css";

const EventPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter table rows based on search input
  const filteredCoordinators = campDetails.coordinators.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.organization.toLowerCase().includes(term) ||
      item.venue.toLowerCase().includes(term) ||
      item.coordinator.toLowerCase().includes(term) ||
      item.doctorName.toLowerCase().includes(term) ||
      item.roomNo.toLowerCase().includes(term) ||
      item.phone.includes(term)
    );
  });

  return (
    <Fragment>
      <Header hclass={"header--styleFour"} />
      <main className="main">
        <PageTitle pageTitle={"Events"} pagesub={"Events"} />
        <div className="about position-relative pt-125 pb-130">
          <div className="container">
            {/* Section Header */}
            <div className="row">
              <div className="col-12">
                <div className="sectionTitle text-center mb-50">
                  <span className="sectionTitle__small justify-content-center">
                    <i className="fa-solid fa-heart btn__icon"></i>
                    Our Mission in Action
                  </span>
                  <h2 className="sectionTitle__big mb-2">
                    Mega Blood Donation Camp
                  </h2>
                  <div className="mt-3">
                    <span className="camp-date-badge">
                      <i className="fa-solid fa-calendar-day me-1"></i> Date: 06-08-2026
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Coordinators & Blood Bank Data Table Section */}
            <div className="row">
              <div className="col-12">
                <div className="coordinators-container">
                  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                    <div>
                      <h4 className="fw-bold m-0" style={{ color: "#1e1b4b" }}>
                        <i className="fa-solid fa-users-gear me-2 text-danger"></i>
                        Bhavan Wise Coordinators & Blood Bank Details
                      </h4>
                      <p className="text-muted small m-0 mt-1">
                        Find venues, room numbers, coordinators, and doctor contacts
                      </p>
                    </div>

                    {/* Search Input Bar */}
                    <div className="input-group" style={{ maxWidth: "340px" }}>
                      <span className="input-group-text bg-white border-end-0">
                        <i className="fa-solid fa-magnifying-glass text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search venue, coordinator, room..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Responsive Table */}
                  <div className="table-responsive">
                    <table className="project-theme-table align-middle">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "50px" }}>S.No</th>
                          <th>Name of the Organization</th>
                          <th>Venue</th>
                          <th className="text-center" style={{ width: "90px" }}>Room No</th>
                          <th>Venue Coordinators</th>
                          <th className="text-center">Phone No</th>
                          <th>Doctor Details</th>
                          <th className="text-center" style={{ width: "160px" }}>Venue Monitors</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCoordinators.map((row, idx) => (
                          <tr key={row.sNo}>
                            <td className="text-center fw-bold">{row.sNo}</td>
                            <td className="fw-bold" style={{ color: "#0f172a" }}>{row.organization}</td>
                            <td>{row.venue}</td>
                            <td className="text-center">
                              <span className="room-badge">{row.roomNo}</span>
                            </td>
                            <td>
                              <div className="fw-bold">{row.coordinator}</div>
                              <div className="text-muted small">{row.designation}</div>
                            </td>
                            <td className="text-center">
                              {row.phone.split("/").map((num, i) => (
                                <div key={i}>
                                  <a href={`tel:${num.trim()}`} className="phone-badge">
                                    <i className="fa-solid fa-phone small"></i> {num.trim()}
                                  </a>
                                </div>
                              ))}
                            </td>
                            <td>
                              <div className="fw-bold">{row.doctorName}</div>
                              <div>
                                <a href={`tel:${row.doctorPhone}`} className="phone-badge">
                                  <i className="fa-solid fa-phone small"></i> {row.doctorPhone}
                                </a>
                              </div>
                            </td>
                            {/* Venue Monitors Column */}
                            {searchTerm ? (
                              <td className="monitor-cell">
                                <div className="fw-bold">{row.monitor}</div>
                                <small>
                                  <a href={`tel:${row.monitorPhone}`} className="phone-badge">
                                    {row.monitorPhone}
                                  </a>
                                </small>
                              </td>
                            ) : idx === 0 ? (
                              <td rowSpan={8} className="monitor-cell monitor-cell-top align-middle">
                                <div className="fw-bold mb-1">{campDetails.venueMonitors[0].name}</div>
                                <div>
                                  <a href={`tel:${campDetails.venueMonitors[0].phone}`} className="phone-badge">
                                    <i className="fa-solid fa-phone small"></i> {campDetails.venueMonitors[0].phone}
                                  </a>
                                </div>
                              </td>
                            ) : idx === 8 ? (
                              <td rowSpan={7} className="monitor-cell align-middle">
                                <div className="fw-bold mb-1">{campDetails.venueMonitors[1].name}</div>
                                <div>
                                  <a href={`tel:${campDetails.venueMonitors[1].phone}`} className="phone-badge">
                                    <i className="fa-solid fa-phone small"></i> {campDetails.venueMonitors[1].phone}
                                  </a>
                                </div>
                              </td>
                            ) : null}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default EventPage;
